/**
* Components are lazy-loaded - See "Grouping Components in the Same Chunk"
* http://router.vuejs.org/en/advanced/lazy-loading.html
*/
/* eslint-disable global-require */
const viewas = r => require.ensure([], () => r(require('./components/viewas')), 'userportalpages');
const viewasNew = r => require.ensure([], () => r(require('./components/viewas_new')), 'userportalpages');
const customize = r => require.ensure([], () => r(require('./components/customize')), 'userportalpages');
const newsUpdates = r => require.ensure([], () => r(require('./components/news_updates')), 'userportalpages');
const customizeLogin = r => require.ensure([], () => r(require('./components/customize_login')), 'userportalpages');
const customize_new = r => require.ensure([], () => r(require('./components/customize_new')), 'userportalpages');
export default [ {
        name: 'viewas',
        path: '/userportal/view-as',
        component: viewas,
    },
    {
        name: 'viewasNew',
        path: '/userportal-v2/view-as',
        component: viewasNew,
    },
    {
        name: 'customize',
        path: '/userportal/customise',
        component: customize,
    },
    {
        name: 'customize_login',
        path: '/userportal/customise-login-page',
        component: customizeLogin,
    },
    {
        name: 'news_updates',
        path: '/userportal/news-updates',
        component: newsUpdates,
    },
    {
        name: 'news_updates_new',
        path: '/userportal-v2/news-updates',
        component: newsUpdates,
    },
    {
        name: 'customize_new',
        path: '/userportal-v2/customise',
        component: customize_new,
    },
    {
        name: 'customize_login_new',
        path: '/userportal-v2/customise-login-page',
        component: customizeLogin,
    },
]



// WEBPACK FOOTER //
// ./src/app/userportalpages/routes.js